<template>
    <v-row class="row--sm">
        <v-col cols="12" lg="6">
            <v-select
                v-model="type"
                v-bind="{
                    ...attrs_input2,
                    items: types,
                    label: readonly ? '판매채널' : '판매채널 수수료율',
                }"
                @input="onChangeType"
            />
        </v-col>
        <v-col cols="12" lg="6">
            <v-currency-field
                v-model="commission"
                v-bind="{
                    ...attrs_input2,
                    decimalLength: {
                        min: 0,
                        max: 2,
                    },
                    readonly,
                    label: readonly ? '수수료율' : '직력입력',
                    suffix: commission ? '%' : undefined,
                }"
                @input="emit"
            />
        </v-col>
    </v-row>
</template>

<script>
import { attrs_input2 } from "@/assets/variables";

const types = [
    {
        text: "직접입력",
        value: "직접입력",
        amount: null,
    },

    {
        text: "네이버 스마트스토어",
        value: "네이버 스마트스토어",
        amount: 6.36,
    },
    {
        text: "쿠팡",
        value: "쿠팡",
        amount: 10.6,
    },
    {
        text: "인터파크/G마켓/옥션/11번가",
        value: "인터파크/G마켓/옥션/11번가",
        amount: 13,
    },
];

export default {
    components: {},
    props: {
        value: { type: Number, default: null },
    },
    setup: () => ({
        attrs_input2,
        types,
    }),
    data: () => ({
        type: "직접입력",
        commission: null,
    }),
    computed: {
        readonly() {
            return this.type != "직접입력";
        },
    },
    methods: {
        sync() {
            let value = (() => {
                if (!this.value) return null;
                let fractionDigits = (`${+this.value}`.split(".")[1]?.length || 2) - 2;
                if (fractionDigits < 0) fractionDigits = 0;
                return +(+this.value * 100).toFixed(fractionDigits);
            })();
            this.commission = value;
        },
        emit() {
            let value = (() => {
                if (!this.commission) return null;
                let fractionDigits = (`${+this.commission}`.split(".")[1]?.length || 0) + 2;
                if (fractionDigits < 0) fractionDigits = 0;
                return +(+this.commission / 100).toFixed(fractionDigits);
            })();
            this.$emit("input", value);
        },
        onChangeType() {
            let type = types.find(({ value }) => value == this.type);
            this.commission = type?.amount || null;
            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
    beforeUnmount() {},
};
</script>

<style lang="scss" scoped>
.v-input {
    ::v-deep(.v-label) {
        background: #fff;
        padding-right: 6px;
        &:not(.v-label--active) {
            top: 14px;
            font-size: 14px;
            color: var(--v-grey-lighten1);
        }
    }
}
</style>
